import { Component } from '@angular/core';
import { PlayerClass } from './models/models';
import { DataStoreService } from './data-store.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isCollapsed = true;
  constructor(public store: DataStoreService) { }

  ngOnInit(): void {
    this.store.Load();
  }

}
